import React, { useEffect } from "react";
import { useHeaderContext } from "../../../../context/headerContext";
import { useNavigate } from "react-router";
import RedCross from "/public/images/icons/redCross.svg?react";
import Button from "../../../../components/Button";
import { useDrawerContext } from "../../../../context/drawerContext";
import CloseIcon from "/public/images/icons/close.svg?react";
import { Link } from "react-router-dom";

export default function ShopCheckoutSuccess() {
  const { setTitle, setBackButton, setCartButton, setCartButtonFunc } = useHeaderContext();
  const { setOpen, setDrawerContent } = useDrawerContext();
  const navigate = useNavigate();

  useEffect(() => {
    setTitle("CHECKOUT");
    setBackButton(true);
    setCartButton(true);

    const handleCartButton = () => {
      navigate('/cart');
    };

    setCartButtonFunc(handleCartButton);
  }, []);

    const supportDrawer = () => {
        setOpen(true);
        setDrawerContent(
            <div className="w-full not-your-band">
                <div className="flex items-center justify-between w-full">
                    <br />
                    <h2 className="leading-5 tracking-widest uppercase text-[12px]">
                        CONTACT SUPPORT
                    </h2>
                    <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
                </div>
                <div className="mt-6 flex flex-col gap-4 justify-stretch">
                    <h3 className="text-[24px]">Please contact us</h3>
                    
                    <div className='flex flex-col'>
                        <p className="text-sportsDarkGrey">Let us know the issue you've ran in to and we will look into it for you.</p>
                        <p className="text-sportsDarkGrey">Our offices are open Monday - Friday between 09:00 - 16:30.</p>
                    </div>

                    <div className="flex flex-col gap-6">
                        <Link href="tel:08009993669">
                            <div className="flex gap-2">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_7364_11237)">
                                    <path d="M5 4H9L11 9L8.5 10.5C9.57096 12.6715 11.3285 14.429 13.5 15.5L15 13L20 15V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21C14.0993 20.763 10.4202 19.1065 7.65683 16.3432C4.8935 13.5798 3.23705 9.90074 3 6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4Z" stroke="#101820" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_7364_11237">
                                    <rect width="24" height="24" fill="white"/>
                                    </clipPath>
                                </defs>
                                </svg>
                                <span className="underline font-semibold text-sportsBlack">0800 999 3669</span>
                            </div>
                        </Link>

                        <Link href="mailto:hello@sportsguardian.com">
                            <div className="flex gap-2">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_7364_11242)">
                                    <path d="M3 7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7V17C21 17.5304 20.7893 18.0391 20.4142 18.4142C20.0391 18.7893 19.5304 19 19 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17V7Z" stroke="#101820" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M3 7L12 13L21 7" stroke="#101820" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_7364_11242">
                                    <rect width="24" height="24" fill="white"/>
                                    </clipPath>
                                </defs>
                                </svg>
                                <span className="underline font-semibold text-sportsBlack">hello@sportsguardian.com</span>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

  return (
    <div className="mt-[24px]">
      <div className="flex flex-col border-b border-dashed pb-[24px] mb-[24px] gap-[24px]">
        <RedCross />
        <p className="text-[32px] font-semibold text-sportsBlack">Payment<br /> Unsuccessful!</p>
        <p className="text-[#909090] font-normal">Unfortunately, we couldn't process your purchase at this time. Please try again or <span className='underline text-sportsBlack' onClick={supportDrawer}>contact support</span> for assistance.</p>
      </div>
      <div className="flex flex-col gap-[12px]">
        <Button variant="primary" className="w-full" href="/">Go Home</Button>
        <Button variant="quaternary" className="w-full" onClick={() => navigate(-1)}>Try Again</Button>
      </div>
    </div>
  );
}